import axios from 'axios';
import { requestInterceptor } from './interceptors/request';
import { responseInterceptor } from './interceptors/response';

// Request interceptor: runs BEFORE the HTTP request is sent
// Use this for outbound data (e.g., adding headers, logging outgoing requests)
axios.interceptors.request.use(requestInterceptor);

// Response interceptor: runs AFTER the HTTP response is received
// Use this for incoming data (e.g., logging, transforming responses, global error handling)
axios.interceptors.response.use(responseInterceptor);
